<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12.667"
    height="16"
    viewBox="0 0 12.667 16"
  >
    <g transform="translate(-410 -360)">
      <path
        :fill="iconColor"
        class="a"
        d="M513.145,499.356h.025a.333.333,0,0,0,.308-.357l-.71-9.737a.333.333,0,1,0-.665.049l.71,9.737A.333.333,0,0,0,513.145,499.356Z"
        transform="translate(-98.699 -124.654)"
      />
      <path
        :fill="iconColor"
        class="a"
        d="M646.908,499.354h.025a.333.333,0,0,0,.332-.309l.71-9.737a.333.333,0,1,0-.665-.049L646.6,499A.333.333,0,0,0,646.908,499.354Z"
        transform="translate(-228.713 -124.653)"
      />
      <path
        :fill="iconColor"
        class="a"
        d="M590.333,499.349a.333.333,0,0,0,.333-.333v-9.737a.333.333,0,0,0-.667,0v9.737A.333.333,0,0,0,590.333,499.349Z"
        transform="translate(-174 -124.647)"
      />
      <path
        :fill="iconColor"
        class="a"
        d="M422.667,362.667a1,1,0,0,0-1-1h-3.333V361a1,1,0,0,0-1-1h-2a1,1,0,0,0-1,1v.667H411a1,1,0,0,0-.158,1.984l1.341,11.466a1,1,0,0,0,.993.884h6.315a1,1,0,0,0,.993-.884l1.341-11.466A1,1,0,0,0,422.667,362.667ZM415,361a.334.334,0,0,1,.333-.333h2a.334.334,0,0,1,.333.333v.667H415Zm4.822,14.039a.333.333,0,0,1-.331.295h-6.315a.333.333,0,0,1-.331-.295l-1.33-11.372h9.637ZM421.667,363H411a.333.333,0,1,1,0-.667h10.667a.333.333,0,1,1,0,.667Z"
      />
    </g>
  </svg>
</template>

<script>
  import { computed } from 'vue'
  import { useTheme } from 'vuetify'
  export default {
    name: 'DeleteIcon',
    setup() {
      const theme = useTheme()
      const iconColor = computed(() =>
        theme.global.current.value.dark ? '#CECECE' : '#383935'
      )

      return {
        iconColor,
      }
    },
  }
</script>

<style scoped>
  svg {
    width: 12.667px;
    height: 16px;
  }
  svg {
    transition: all 0.3s ease-in-out;
  }
  svg:hover {
    transform: scale(1.2);
  }
  /* svg:hover path {
        fill: #592892 !important;
    } */
</style>
